import types from '../../mutation-types';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';

export const mutations = {
  [types.SET_AUDIT_LOGS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_AUDIT_LOGS]: MutationHelpers.set,
  [types.SET_AUDIT_LOGS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.SET_AUDIT_LOGS_FILTERS](_state, data) {
    _state.appliedFilters = data;
  },
  [types.CLEAR_AUDIT_LOGS_FILTERS](_state) {
    _state.appliedFilters = [];
  },
  [types.SET_AUDIT_LOGS_SEARCH_QUERY]: ($state, data) => {
    $state.searchQuery = data;
  },
  [types.SET_AUDIT_LOGS_FILTER_QUERY]: ($state, query) => {
    $state.currentFilterQuery = query;
  },
  [types.SET_AUDIT_LOGS_EXPORT_TYPE]: ($state, exportType) => {
    $state.exportType = exportType;
  },
};
